import { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import { DashboardLayout } from '@/layouts/DashboardLayout';
import { setUnauthorizedHandler } from '@/lib/api-client';
import { AdminLoginPage } from '@/pages/AdminLoginPage';
import { ContractorForm } from '@/pages/ContractorForm';
import { Contractors } from '@/pages/Contractors';
import { Dashboard } from '@/pages/Dashboard';
import { LenderForm } from '@/pages/LenderForm';
import { Lenders } from '@/pages/Lenders';
import { ListingForm } from '@/pages/ListingForm';
import { Listings } from '@/pages/Listings';
import { Settings } from '@/pages/Settings';
import { useAuthStore } from '@/stores/useAuthStore';

function App() {
  // Set up global 401 handler to clear session on unauthorized responses
  useEffect(() => {
    const clearSession = useAuthStore.getState().clearSession;
    setUnauthorizedHandler(() => {
      clearSession();
      // ProtectedRoute will automatically redirect to /login
    });
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* Public route */}
        <Route path="/login" element={<AdminLoginPage />} />

        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="listings" element={<Listings />} />
            <Route path="listings/new" element={<ListingForm />} />
            <Route path="listings/:id/edit" element={<ListingForm />} />
            <Route path="contractors" element={<Contractors />} />
            <Route path="contractors/new" element={<ContractorForm />} />
            <Route path="contractors/:id/edit" element={<ContractorForm />} />
            <Route path="lenders" element={<Lenders />} />
            <Route path="lenders/new" element={<LenderForm />} />
            <Route path="lenders/:id/edit" element={<LenderForm />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Route>

        {/* Catch all - redirect to dashboard */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
